import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="system-notification-toggle"
// Controller for reopen buttons that toggles notification visibility
export default class extends Controller {
  static values = { id: Number }
  static outlets = ["system-notification-item"]
  static targets = ["tooltip"]

  toggle() {
    if (this.hasSystemNotificationItemOutlet) {
      this.systemNotificationItemOutlet.toggle()
    }
  }

  showTooltip() {
    if (this.hasTooltipTarget) {
      this.tooltipTarget.classList.remove('hidden')
    }
  }

  hideTooltip() {
    if (this.hasTooltipTarget) {
      this.tooltipTarget.classList.add('hidden')
    }
  }
}

